import { DictionaryNaceAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useNaceItems() {
  return useAutocompleteSource<DictionaryNaceAutocomplete>({
    url: EvidenceAPI.DICTIONARY_NACES + '/autocomplete',
  });
}
